var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('div',{staticClass:"imgbg"}),_c('h1',[_c('div')]),_c('p',[_vm._v("持续创新，量身打造")])])
}]

export { render, staticRenderFns }